import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../helpers';
import { TREATMENT_PLANS_V2_API_BASE } from '../../constants';

import type {
  ITreatmentPlanV3TreatmentPage,
  GetTreatmentPlanV3TreatmentPagePayload,
  UpdateTreatmentPlanV3TreatmentPagePayload,
} from './types';

export function createTreatmentPlanV3TreatmentThunks() {
  return {
    getTreatmentPlanV3TreatmentPage: getTreatmentPlanV3TreatmentPage(),
    updateTreatmentPlanV3TreatmentPage: updateTreatmentPlanV3TreatmentPage(),
  };
}

function getTreatmentPlanV3TreatmentPage() {
  return createAsyncThunk<ITreatmentPlanV3TreatmentPage, GetTreatmentPlanV3TreatmentPagePayload>(
    'treatmentPlanV3/getTreatmentPlanV3TreatmentPage',
    async ({ treatmentPlanId, getAccessTokenSilently }) =>
      fetchWrapper.get({
        url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/treatment/`,
        getAccessTokenSilently,
      }),
  );
}

function updateTreatmentPlanV3TreatmentPage() {
  return createAsyncThunk<
    ITreatmentPlanV3TreatmentPage,
    UpdateTreatmentPlanV3TreatmentPagePayload
  >(
    'treatmentPlanV3/updateTreatmentPlanV3TreatmentPage',
    async ({ treatmentPlanId, data, getAccessTokenSilently }) =>
      fetchWrapper.patch(
        {
          url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/treatment/`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}
